import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, inject, OnDestroy, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { FormioModule } from '@formio/angular';

import { FormIoViewData } from '../../shared/models/formio.model';
import { SchemaService } from '../../shared/services/schema.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { FormioSchemaComponent } from "./formio-schema/formio-schema.component";
import { TranslocoDirective } from '@jsverse/transloco';
import { BreadcrumbComponent } from "../../shared/components/breadcrumb/breadcrumb.component";
import { SchemaRepository } from '../../shared/repositories/schema.repository';
import { SchemaInfo } from '../../shared/models/schema.model';
import { OverlayLoadingSpinnerBorderComponent } from "../../shared/components/loading/overlay-loading-spinner-border/overlay-loading-spinner-border.component";
import { SchemaAccessStatus } from '../../shared/enums/schema-status';
import { AssistedAccessDialogComponent } from '../patient/assisted-access-dialog/assisted-access-dialog.component';
import { Modal } from 'bootstrap';

@Component({
    selector: 'schema',
    templateUrl: './schema.component.html',
    styleUrl: './schema.component.scss',
    imports: [CommonModule, FormioModule, FormioSchemaComponent, TranslocoDirective, BreadcrumbComponent, OverlayLoadingSpinnerBorderComponent, AssistedAccessDialogComponent]
})
export class SchemaComponent implements OnInit, OnDestroy {
    private schemaStore = inject(SchemaRepository);

    @ViewChild(FormioSchemaComponent) formIoSchemaComponent?: FormioSchemaComponent;

    schemaInfo!: SchemaInfo;
    schemaId!: number;

    formioData: FormIoViewData | null = null;
    
    isLoading: WritableSignal<boolean> = signal(false);
    hasSchemaError: WritableSignal<boolean> = signal(false);

    constructor(
        private readonly navigation: NavigationService,
        private readonly route: ActivatedRoute,
        private readonly schemaService: SchemaService,
        private readonly router: Router
    ) { }

    ngOnInit(): void {
        this.schemaId = <number><unknown>this.route.snapshot.paramMap.get("schemaid");
        this.getSchemaData();
        this.schemaStore.getSchemaInfo$(this.schemaId).subscribe({
            next: (data: SchemaInfo) => {
                this.schemaInfo = data;
            }
        });
    }

    ngOnDestroy(): void {
        this.hasSchemaError.set(false);
    }

    getSchemaData() {
        this.isLoading.set(true)

        this.schemaService.getFormIoSchemaById(this.schemaId).subscribe({
            next: (data) => {
                if(data.accessStatus == SchemaAccessStatus.Denied){
                    alert('Du har ikke adgang til dette skema.');
                    this.router.navigate(['/schemas']);
                }
                else if(data.accessStatus == SchemaAccessStatus.Assisted){
                    const modalEl = document.getElementById('assistedDialog');
                    if (modalEl) {
                         const modal = new Modal(modalEl);
                         modal.show();
                    }
                }
                else{
                    this.formioData = {
                        formName: data.formName,
                        formIoJson: JSON.parse(data.formIoJsonObject),
                        translationsJson: data.translationsJsonObject,
                        answerJson: JSON.parse(`{"data": ${data.answersJsonObject}}`),
                        state: data.state,
                        style: data.style,
                        schemaId: this.schemaId,
                        guidanceUrl: data.guidanceUrl,
                        version: data.version
                    }
                }

            },
            error: () => {
                this.isLoading.set(false);
                this.hasSchemaError.set(true);
            },
            complete: () => {
                this.isLoading.set(false);
            },
        })
    }

    onBackClicked() {
        this.navigation.back();
    }

}
